export default import.meta.ROLLDOWN_FILE_URL_Gbyj8dAVPP$N5n3vBvuBIg